var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"radio-button",class:{
    'text-red-primary': _vm.selected,
    'border-gray-150': !_vm.selected,
    'border-red-primary': _vm.selected,
  },on:{"click":function($event){return _vm.$emit('onClick', !_vm.selected)}}},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }